import { Head, Link } from "@inertiajs/react"

import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import AuthLayout from "@/layouts/auth-layout"
import { newUserSessionPath } from "@/routes"

export default function PasswordResetSuccess() {
  return (
    <AuthLayout title="" description="">
      <Head title="Password reset successful" />
      <div className="flex w-full flex-col gap-6">
        <Card>
          <CardHeader className="text-center">
            <CardTitle className="text-xl">Password reset successful</CardTitle>
            <CardDescription>
              Your password has been updated. You can now log in with your new
              password.
            </CardDescription>
          </CardHeader>
          <CardContent className="flex justify-center">
            <Button asChild className="w-full">
              <Link href={newUserSessionPath()}>Continue to login</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </AuthLayout>
  )
}
